import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './reducers/rootReducer'

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose

const enhancer = composeEnhancers(applyMiddleware())

export default function configureStore(initialState = {}) {
  const store = createStore(rootReducer(), initialState, enhancer)
  return store
}
